export default __webpack_public_path__ + "static/grand_senora_desert_meth_lab-c05a26b5d0c1fe8fd05731083172fc59.png";